import React, { Component } from "react";
import { Input } from "reactstrap";
import { Search } from "react-feather";
import SearchResults from "react-filter-search";
import FilterBottomSheets from "views/ITV-details/components/FilterBottomSheets";
//IMG
import filter from "views/ITV-details/img/filter.png";
import { setMgToken, setHcToken } from "store/Auth";
import { connect } from "react-redux";
import cardplaybtn from "views/ITV-details/img/card-playbtn.png";
import Token from "api/Auth/auth";
import store from "store.js";
import { getITVAction } from "store/Home";

class AllJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      filter: false,
      search: "",
    };
    this.bottomSheet = React.createRef();
  }
  async componentDidMount() {
    let HcToken = await Token.getToken();
    store.dispatch(setHcToken(HcToken));
    let MgToken = await Token.getTokenMagitt();
    store.dispatch(setMgToken(MgToken));
    let responseGetItv = await this.props.getITVAction();
    this.setState({ jobs: responseGetItv });

    // console.log(responseGetItv);
  }
  handleFilter() {
    if (window.innerWidth > 575) {
      this.setState({ filter: !this.state.filter });
    } else {
      this.bottomSheet.current.toggleBottomSheet();
    }
  }
  render() {
    return (
      <div>
        <FilterBottomSheets ref={this.bottomSheet} />
        <div className=" pb-8 lg:pt-16 md:pt-16 pt-0 lg:px-0 md:px-0 px-4 lg:mt-0 md:mt-0 mt-4">
          <div className="button-section flex sm-reverse-btn">
            <button
              className="filter-btn flex justify-center items-center font-semibold fsize16 md:mr-8 lg:mr-8"
              onClick={() => this.handleFilter()}
            >
              <p className="mr-3">FILTERS</p>
              <img src={filter} alt="filter" />
            </button>

            <h2 className="fsize28 font-bold uppercase text-black sm-fsize16">
              iTV
            </h2>
          </div>

          <div className="mt-10 flex">
            {this.state.filter && (
              <div className="filter lg:w-1/4 md:w-1/4 w-3/5 pr-6">
                <card className="rounded-12px drop-shadow20px block p-6 ">
                  <div className="flex justify-between">
                    <h1 className="fsize18 text262626 font-semibold">
                      Filters
                    </h1>
                    <p className="fsize16 textE77817 underline  ">Clear all</p>
                  </div>

                  <div className="relative  mt-6 mb-8">
                    <Search
                      width="18"
                      height="18"
                      className="absolute filter-searchicon"
                    />
                    <Input
                      type="text"
                      name="search"
                      className="w-full cust-shadow-md py-3 pl-12 pr-4 text#4B4B4B opacity-60per fsize14 rounded-full "
                      placeholder="Search..."
                      value={this.state.search}
                      onChange={(e) => {
                        this.setState({ search: e.target.value });
                      }}
                    />
                  </div>

                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">Domain</h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Campus Selection
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Human Resource
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* category */}
                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">
                      Category
                    </h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              0-2
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              2-5
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              5-7
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          0
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              7-10
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          5
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              10+
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          2
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* type */}
                  <div className="mb-6">
                    <h1 className="fsize16 text262626 font-semibold">Type</h1>
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Jobs
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          16
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Event
                            </p>
                            <input type="checkbox" checked />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          8
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Bank
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          0
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              General
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          5
                        </p>
                      </div>

                      <div className="flex justify-between">
                        <div className="flex items-center ">
                          {/* <input type="checkbox" className="w-18px h-18px " /> */}
                          <label class="custcheckbox">
                            <p className="text262626 fsize14 opacity-80per ml-2">
                              Others
                            </p>
                            <input type="checkbox" />
                            <span class="overhide-span"></span>
                          </label>
                        </div>
                        <p className="text262626 fsize14 opacity-80per ml-2">
                          2
                        </p>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            )}

            <div
              className={`all-jobscard lg:gap-6 md:gap-6 gap-4 grid  ${
                this.state.filter
                  ? "lg:w-3/4 md:w-3/4 w-2/5 lg:grid-cols-3 md:grid-cols-3 grid-cols-1"
                  : "w-full lg:grid-cols-4 md:grid-cols-4 grid-cols-2"
              }`}
            >
              <SearchResults
                value={this.state.search}
                data={this.state.jobs}
                renderResults={(results) => (
                  <>
                    {results.map((val) => (
                      <card className="rounded-12px drop-shadow block ">
                        <div className="relative">
                          <video
                            controls
                            className="w-full min-h-171px rounded-t-15px sm-h95px "
                          >
                            <source
                              src={
                                process.env.REACT_APP_IMAGE_BASE_MG +
                                "/" +
                                val.b_path
                              }
                              alt="jobvideo"
                              type="video/mp4"
                              className="w-full"
                            />
                          </video>
                          <div className="w-full flex justify-center items-center"></div>
                        </div>

                        <div className="lg:p-6 md:p-6 p-4">
                          <h1 className="fsize18 mob-fsize14 font-bold">
                            {val.b_title || "Video"}
                          </h1>
                          <p className="text262626 fsize12 opacity-80per line-h20 pt-2 lg:block md:block hidden">
                            {val.b_description ||
                              `ICICI Bank launches novel women centric initiatives on
                    International Women’s Day…`}
                          </p>

                          <p className="dashed-border-b mt-4 lg:block md:block hidden"></p>

                          <div className="lg:mt-4 md:mt-4 mt-3 flex items-center">
                            <div class="chips-orange40 flex justify-center items-center font-semibold">
                              <p class=" fsize11 mob-fsize9 textF06321 uppercase">
                                {val.Tags || "No Tags"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </card>
                    ))}
                  </>
                )}
              />
              {/* {this.state.jobs
            // .filter((val)=> {val.b_title.includes(this.state.search)})
            .map((val, index) => {
              return (
                <card className='rounded-12px drop-shadow block '>
                  <div className='relative'>
                    <video controls className='w-full'> 
                    <source
                    src={process.env.REACT_APP_IMAGE_BASE_MG+'/'+val.b_path}
                     alt='jobvideo' type="video/mp4"
                     className='w-full'
                    /> 
                    </video>
                    <div className='w-full flex justify-center items-center'>
                    </div>
                  </div>

                  <div className='lg:p-6 md:p-6 p-4'>
                    <h1 className='fsize18 mob-fsize14 font-bold'>
                      {val.b_title || 'Video'}
                    </h1>
                    <p className='text262626 fsize12 opacity-80per line-h20 pt-2 lg:block md:block hidden'>
                      {val.b_description || `ICICI Bank launches novel women centric initiatives on
                      International Women’s Day…`}
                    </p>

                    <p className='dashed-border-b mt-4 lg:block md:block hidden'></p>

                    <div className='lg:mt-4 md:mt-4 mt-3 flex items-center'>
                      <div class='chips-orange40 flex justify-center items-center font-semibold'>
                        <p class=' fsize11 mob-fsize9 textF06321 uppercase'>
                          {val.Tags || 'No Tags'}
                        </p>
                      </div>
                    </div>
                  </div>
                </card>
              );
            })} */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  // console.log("homemap", JSON.stringify(state.Home.home.GETITV));
  return {
    getitv: state.Home.home.GETITV,

    // dashboard: state.dashboard.dashboard,
    // document: state.document.document,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getITVAction: async () => await dispatch(getITVAction()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AllJobs);
